(function() {
  "use strict";
  angular.module("marketPlace.searches", []);
})();
